import { useSuspenseQuery } from '@tanstack/react-query';

import type { AuditListResult } from '@/api/types/audit';

import { getAudit } from '../generated';
import type { GetAuditData } from '../generated';

function useList(queryParams: GetAuditData['query']) {
  return useSuspenseQuery({
    queryKey: ['auditLogs', 'list', queryParams],
    queryFn: async () => {
      const { data } = await getAudit({
        query: {
          ...queryParams,
          page: queryParams?.page ? queryParams.page + 1 : 1,
        },
      });
      if (!data) throw new Error('Failed to fetch audit logs');
      return data as AuditListResult;
    },
  });
}

export const auditLogsApi = {
  useList,
};
